export const EventProp = Object.freeze({
    EventType: 'eventType',
    Action: 'action'
});